const MESSAGE_BOX_SHOW = 'MESSAGE_BOX_SHOW'
const MESSAGE_BOX_HIDE = 'MESSAGE_BOX_HIDE'

export { MESSAGE_BOX_SHOW, MESSAGE_BOX_HIDE }
